/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Beweegthema_Stoeispelen2Inputs */

const nl_enums_beweegthema_stoeispelen2 = /** @type {(inputs: Enums_Beweegthema_Stoeispelen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stoeispelen`)
};

/**

* @param {Enums_Beweegthema_Stoeispelen2Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_beweegthema_stoeispelen2 = /** @type {((inputs?: Enums_Beweegthema_Stoeispelen2Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Beweegthema_Stoeispelen2Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_beweegthema_stoeispelen2(inputs)
});
export { enums_beweegthema_stoeispelen2 as "enums.Beweegthema.Stoeispelen" }